import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full"]

  showFull(event) {
    event.preventDefault()
    this.previewTarget.classList.add("hidden")
    this.fullTarget.classList.remove("hidden")
  }

  showPreview(event) {
    event.preventDefault()
    this.previewTarget.classList.remove("hidden")
    this.fullTarget.classList.add("hidden")
  }
}